import { isCssVar } from './utils/css-var.es.js';
import { getStyleName } from './utils/get-style-name.es.js';
import { transformDefinitions } from './utils/transforms.es.js';
var style = {
  get: function get(element, name) {
    name = getStyleName(name);
    var value = isCssVar(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
    if (!value && value !== 0) {
      var definition = transformDefinitions.get(name);
      if (definition) value = definition.initialValue;
    }
    return value;
  },
  set: function set(element, name, value) {
    name = getStyleName(name);
    if (isCssVar(name)) {
      element.style.setProperty(name, value);
    } else {
      element.style[name] = value;
    }
  }
};
export { style };